import _toArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Wed Aug 08 2018
 * @author BPo
 */


import { FormDefinition, Utils } from '@logio/common-be-fe';
import { action, computed, observable, runInAction } from 'mobx';
import { stringify } from 'querystring';
import createFilterOptions from 'react-select-fast-filter-options';
import translate from '../../../components/i18n/translate';
import { LoadingState } from '../../api/LoadingState';
import { CodeBookItemLayer } from '../../transportLayers/code-book/CodeBookItemLayer';
import { FormLayer } from '../../transportLayers/form/FormLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { CollectLookups } from './CollectLookups';
/**
 * Definition store offers the possibility to get restrictions for the form rendering.
 * You can filter form fields with automatically computed fields value.
 */

export var FormStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(FormStore, _BaseStore);

  function FormStore() {
    var _this;

    _classCallCheck(this, FormStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormStore).apply(this, arguments));
    _this.errorStore = _this.rootStore.getStore(StoreName.Error);
    _this.formLayer = new FormLayer();
    _this.codeBookItemLayer = new CodeBookItemLayer(); // FIXME: BPo This store is not globally accessible. Remove this from the StoreName enum

    _this.name = StoreName.FormStore;
    _this.loadingState = LoadingState.Pending;
    /** Description of forms */

    _this.formDefinition = null;
    /** Map of all lookups */

    _this.lookups = new Map();
    /** Map of all lookups in the SelectOptions format. Use this for fields. Don't map the lookup map! */

    _this.selectOptions = new Map();
    /**
     * Try to find codeBooks for the specific value description
     * @param desc Description of the form field
     */

    _this.getDependentOptions = function (desc, values) {
      var lookupUris = _this.getLookupsUris({
        desc: desc
      }, true);

      var parsedValues = _this.parseOptionValues(values);

      var params = Object.entries(values);

      if (lookupUris.length && params.length) {
        var options = _this.selectOptions.get(_this.getURL(lookupUris[0], parsedValues));

        if (options) {
          return new Promise(function (resolve) {
            resolve(options);
          });
        } else {
          var promises = lookupUris.map(function (u) {
            return _this.codeBookItemLayer.loadLookup(u, parsedValues);
          });
          return Promise.all(promises).then(function (lookupResponses) {
            var lookups = lookupResponses.map(function (response) {
              response.lookup = _this.getURL(lookupUris[0], parsedValues);
              return response;
            });
            return _this.saveLookups(lookups).values().next().value;
          });
        }
      }

      return new Promise(function (resolve) {
        resolve(null);
      });
    };
    /**
     * Changes loading state
     * @param state should represent data
     */


    _this.setLoadingState = function (state) {
      _this.loadingState = state;
    };

    return _this;
  }
  /**
   * This will save the form definition manually.
   * @param formDefinition
   */


  _createClass(FormStore, [{
    key: "setFormDefinition",
    value: function setFormDefinition(formDefinition) {
      this.formDefinition = formDefinition; // Chain the init method after this

      return this;
    }
    /**
     * Transforms data into a more usable form.
     * @param fields List of form field description
     */

  }, {
    key: "mapDefinitionFields",
    value: function mapDefinitionFields() {
      var formDefinition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formDefinition;
      var mapped = new Map();
      formDefinition.fields.forEach(function (field) {
        mapped.set(field.name, field);
      });
      return mapped;
    }
    /**
     * List of form definition fields. This will be computed automatically by mobX.
     */

  }, {
    key: "loadLookups",
    // @computed
    // get options(): Map<string, SelectOption[]> {
    //   const lookupOptions: Map<string, SelectOption[]> = new Map();
    //   for (const [key, value] of this.lookups) {
    //     const options = value.map((codebookItem) => {
    //       return {
    //         label: codebookItem.title,
    //         value: codebookItem.id,
    //       };
    //     });
    //     lookupOptions.set(key, options);
    //   }
    //   return lookupOptions;
    // }

    /**
     * This will load all lookups and returns array of all promises.
     * @param descriptions Descriptions of the form field
     */
    value: function loadLookups(descriptions) {
      var _this2 = this;

      var lookupUris = this.getLookupsUris(descriptions);
      return lookupUris.map(function (u) {
        return _this2.codeBookItemLayer.loadLookup(u);
      });
    }
    /**
     * Try to find all lookup urls recursively
     * @param descriptionsProp Descriptions of the form field
     * @param includeOptional Optional parameter that is disabled by default. If the value is true, it
     * will return even those lookups that need mandatory arguments.
     */

  }, {
    key: "getLookupsUris",
    value: function getLookupsUris(descriptionsProp) {
      var includeOptional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var lookups = new CollectLookups();
      var descriptions = lookups.visitDataDesc(descriptionsProp);

      if (includeOptional) {
        return Array.from(descriptions, function (description) {
          return description.lookup;
        });
      }

      var lookupUris = [];
      descriptions.forEach(function (description) {
        if (description.mandatoryParameter === true) {
          return;
        }

        lookupUris.push(description.lookup);
      });
      return lookupUris;
    }
    /**
     * Try to find codeBooks for the specific value description
     * @param desc Description of the form field
     */

  }, {
    key: "getCodeBooks",
    value: function getCodeBooks(desc) {
      var lookupUris = this.getLookupsUris({
        desc: desc
      });

      if (lookupUris.length) {
        // NOTE: Not sure if this is the best solution. Should we merge and show multiple code-books?
        return this.lookups.get(lookupUris[0]);
      }

      return null;
    }
    /**
     * Try to find codeBooks for the specific value description
     * @param desc Description of the form field
     */

  }, {
    key: "getOptions",
    value: function getOptions(desc) {
      var lookupUris = this.getLookupsUris({
        desc: desc
      });

      if (lookupUris.length) {
        // NOTE: Not sure if this is the best solution. Should we merge and show multiple codebooks?
        return this.selectOptions.get(lookupUris[0]);
      }

      return null;
    }
    /**
     * Parse dependent values to string
     * @param values
     */

  }, {
    key: "parseOptionValues",
    value: function parseOptionValues(values) {
      var parser = function parser(value) {
        if (Utils.isMoment(value)) {
          return value.toISOString();
        }

        return value;
      };

      var parsedValues = {};
      Object.entries(values).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        parsedValues[key] = parser(value);
      });
      return parsedValues;
    }
    /**
     * When query string set url will be merged with the given query string.
     */

  }, {
    key: "getURL",
    value: function getURL(uri, queryObj) {
      var queryString = stringify(queryObj);
      return queryString ? "".concat(uri, "?").concat(queryString) : uri;
    }
    /**
     * Transform codeBook item to the selectOption (label, value pair)
     * @param codeBook Codebook item with identifier and title for UI.
     */

  }, {
    key: "codeBookToOption",
    value: function codeBookToOption(codeBook) {
      var title = translate(codeBook.title);
      return {
        label: title,
        value: codeBook.id,
        title: title
      };
    }
    /**
     * Transform lookup response to the lookup map item
     * @param lookupResponses Responses from the code book item transport layer
     */

  }, {
    key: "saveLookups",
    value: function saveLookups(lookupResponses) {
      var _this3 = this;

      var newOptions = new Map(); // The rest of answers are lookups

      lookupResponses.forEach(function (lookupResponse) {
        _this3.lookups.set(lookupResponse.lookup, lookupResponse.codeBooks);

        var options = lookupResponse.codeBooks.map(function (codeBook) {
          return _this3.codeBookToOption(codeBook);
        });
        newOptions.set(lookupResponse.lookup, {
          options: options,
          filterOptions: createFilterOptions({
            options: options
          })
        });

        _this3.selectOptions.set(lookupResponse.lookup, {
          options: options,
          filterOptions: createFilterOptions({
            options: options
          })
        });
      });
      return newOptions;
    }
    /**
     * Perform all form definition and lookup requests
     * @param descriptions Descriptions of the form field
     * @param path Path to the form definition endpoint
     */

  }, {
    key: "load",
    value: function load(descriptions, customDefinition) {
      var _this4 = this;

      if (customDefinition) {
        var promises = []; // Load form definition when path is passed

        promises.push(this.formLayer.loadDefinition(customDefinition.path, customDefinition.params)); // Load all lookups when exist

        promises.push.apply(promises, _toConsumableArray(this.loadLookups(descriptions)));
        Promise.all(promises).then(function (_ref3) {
          var _ref4 = _toArray(_ref3),
              formDefinitionResponse = _ref4[0],
              lookupResponses = _ref4.slice(1);

          runInAction(function () {
            // First response is from the form definition endpoint
            if (formDefinitionResponse instanceof FormDefinition) {
              _this4.formDefinition = formDefinitionResponse;
            }

            _this4.saveLookups(lookupResponses); // Loading state


            _this4.setLoadingState(LoadingState.Success);
          });
        });
      } else {
        var _promises = []; // Load all lookups when exist

        _promises.push.apply(_promises, _toConsumableArray(this.loadLookups(descriptions)));

        Promise.all(_promises).then(function (values) {
          runInAction(function () {
            _this4.saveLookups(values); // Loading state


            _this4.setLoadingState(LoadingState.Success);
          });
        }).catch(function (error) {
          _this4.setLoadingState(LoadingState.Error);
        });
      }
    }
  }, {
    key: "fields",
    get: function get() {
      return this.formDefinition ? this.mapDefinitionFields() : null;
    }
  }]);

  return FormStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Number)], FormStore.prototype, "loadingState", void 0);

__decorate([observable, __metadata("design:type", FormDefinition)], FormStore.prototype, "formDefinition", void 0);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [FormDefinition]), __metadata("design:returntype", FormStore)], FormStore.prototype, "setFormDefinition", null);

__decorate([computed, __metadata("design:type", Map), __metadata("design:paramtypes", [])], FormStore.prototype, "fields", null);

__decorate([action, __metadata("design:type", Object)], FormStore.prototype, "setLoadingState", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Object]), __metadata("design:returntype", void 0)], FormStore.prototype, "load", null);